import React from 'react';
import HarbourIcon from './HarbourIcon';
import HarbourIconButton from './HarbourIconButton';
import { formatUkPhone, telHref } from '../../utils/contactFormatting';
import './harbour.css';

/*
 * Harbour/Parents box: every parent or carer on the pupil record, one row
 * each. The "Nominated Parent or Carer" marker (the referral wizard's own
 * label) sits on the one the referral nominated, who receives the emails
 * (4223:303920). Records with no referral nominate nobody, so draw no marker
 * (4223:94139 / 94627).
 *
 * onEdit (TDI-622): the same pencil as the teacher row, opening "Change
 * parent or carer".
 */
export default function HarbourParentsBox({ parents = [], onEdit }) {
  if (!parents.length) return null;
  return (
    <div className="harbour-parents-box">
      {parents.map((p) => {
        const name = [p.firstName, p.lastName].filter(Boolean).join(' ');
        return (
          <div key={p.participantId || p.email} className="harbour-parents-box__row">
            <div className="flex flex-col min-w-0">
              <span className="harbour-parents-box__label">Parent or carer</span>
              <span className="harbour-parents-box__name">
                {name || p.email}
                {p.isInformant && (
                  <span className="harbour-informant-marker">Nominated Parent or Carer</span>
                )}
              </span>
            </div>
            <div className="ml-auto flex items-center gap-6 flex-wrap justify-end">
              {p.phone && (
                <a className="harbour-parents-box__contact" href={telHref(p.phone)}>
                  <HarbourIcon name="phone" size={20} />
                  {formatUkPhone(p.phone)}
                </a>
              )}
              {p.email && (
                <a className="harbour-parents-box__contact" href={`mailto:${p.email}`}>
                  <HarbourIcon name="email" size={20} />
                  {p.email}
                </a>
              )}
              {onEdit && (
                <HarbourIconButton
                  kind="ghost"
                  icon="edit"
                  label={`Change ${name || 'this parent or carer'}`}
                  onClick={() => onEdit(p)}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
